import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, ReconciliationColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import MonthFilter from '../common/MonthFilter';
import "./style.css";
import ReportModals from './ReportsModal';
import { toast } from 'react-toastify';
import { getReconciliationReport, getReconciliationTransactionDetails } from '../../store/actions/carrierReconciliationReport.action';
import moment from 'moment';
import { formatNumberWithCommas, formatStaticNumberWithCommas } from '../../config/utils';
import DisputedTransactions from './DisputedList';
import { useNavigate } from 'react-router-dom';

/*istanbul ignore next */
const CarrierReconciliationReports = () => {
    const [showLoader, setShowLoader] = useState(false);
    const { reconciliationReport, loader, reconciliationReportStatus } = useSelector((state) => state.carrierReconciliationReport);
    let dispatch = useDispatch();
    const navigate = useNavigate();
    const [cardsTotalData, setCardsTotalData] = useState({});
    const [selectedRecord, setSelectedRecord] = useState({});
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showDisputedDialogObj, setShowDisputedDialogObj] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [transactionDetailsLoader, setTransactionDetailsLoader] = useState(false);
    const [transactionDetailsTotalRecords, setTransactionDetailsTotalRecords] = useState(0);
    const now = new Date();
    const [reportListing, setReportListing] = React.useState([]);

    const [filterData, setfilterData] = useState({
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        startDate: new Date(now.getFullYear(), now.getMonth(), 1),
        endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        reportTypes: ['USPSPREMIUM']
    });

    useEffect(() => {
        if (reconciliationReport?.data?.monthlyReports?.length) {
            setReportListing(reconciliationReport.data.monthlyReports);
        }
        setCardsTotalData(reconciliationReport?.data?.totals || {});
    }, [reconciliationReport]);

    useEffect(() => {
        fetchReportData();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

    const fetchReportData = async () => {
        try {
            let payload = {
                ...filterData,
                startDate: moment(filterData.startDate).format("YYYY-MM-DDT00:00:00"),
                endDate: moment(filterData.endDate).format("YYYY-MM-DDT00:00:00"),
            };
            dispatch(getReconciliationReport(payload));
        } catch (error) {
            console.error("Error fetching report data", error);
        }
    };

    useEffect(() => {
        if (reconciliationReportStatus === 'PENDING') {
            setShowLoader(true);
        } else if (reconciliationReportStatus === 'SUCCESS' && !_.isEmpty(filterData)) {
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(reconciliationReport?.totalRecords / filterData.pageSize),
            });
            setShowLoader(false);
        }
    }, [reconciliationReportStatus]);

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
            pageIndex: 1
        });
    };

    const handleApplyFilter = (data) => {
        if (!data.startDate && !data.endDate) {
            toast.error("Please select both From Month and To Month");
            return;
        }
        if (filterData.pageIndex === 1) {
            setfilterData({
                ...filterData,
                startDate: data.startDate,
                endDate: data.endDate,
                reportTypes: data.reportTypes
            });
            let payload = {
                ...filterData,
                startDate: moment(data.startDate).format("YYYY-MM-DDT00:00:00"),
                endDate: moment(data.endDate).format("YYYY-MM-DDT00:00:00"),
                reportTypes: data.reportTypes
            };
            dispatch(getReconciliationReport(payload));
        } else {
            setfilterData({
                ...filterData,
                startDate: data.startDate,
                endDate: data.endDate,
                pageIndex: 1,
                reportTypes: data.reportTypes
            });
        }
    };

    // Function to fetch transaction details with pagination and sorting
    const fetchTransactionDetails = async (monthData, isMonth = false, isMatched = false, pageNumber = 1, pageSize = 30, sortColumn = "CreatedDate", sortOrder = "DESCENDING") => {
        setTransactionDetailsLoader(true);
        setTransactionDetails([]); // Clear previous data

        try {
            // Calculate month number from monthName (e.g., "January" -> 1, "February" -> 2, etc.)
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            const monthNumber = monthNames.indexOf(monthData.monthName) + 1;

            // Calculate start and end dates for the selected month
            const startDate = new Date(Date.UTC(monthData.year, monthNumber - 1, 1)).toISOString();
            const endDate = new Date(Date.UTC(monthData.year, monthNumber, 0, 23, 59, 59, 999)).toISOString();

            const payload = {
                tenantId: 1, // Using default tenant ID
                startDate: startDate,
                endDate: endDate,
                isMonth: isMonth,
                isMatch: isMatched, // Default to false, you can make this configurable
                reportTypes: filterData.reportTypes,
                searchText: "",
                sortColumn: sortColumn,
                sortOrder: sortOrder,
                pageIndex: pageNumber,
                pageSize: pageSize
            };

            const result = dispatch(getReconciliationTransactionDetails(payload));

            if (result && typeof result.then === 'function') {
                result.then((res) => {
                    if (res?.success === true) {
                        setTransactionDetails(res.data.entityList || []);
                        setTransactionDetailsTotalRecords(res.data.totalRecords || 0);
                    } else {
                        toast.error(res?.message || 'Failed to fetch transaction details');
                    }
                    setTransactionDetailsLoader(false);
                }).catch((error) => {
                    console.error('Error fetching transaction details:', error);
                    toast.error('Something went wrong while fetching transaction details');
                    setTransactionDetailsLoader(false);
                });
            } else {
                // If result is not a promise, handle immediately
                if (result?.success === true) {
                    setTransactionDetails(result.data.entityList || []);
                    setTransactionDetailsTotalRecords(result.data.totalRecords || 0);
                } else {
                    toast.error(result?.message || 'Failed to fetch transaction details');
                }
                setTransactionDetailsLoader(false);
            }
        } catch (error) {
            console.error('Error fetching transaction details:', error);
            toast.error('Something went wrong while fetching transaction details');
            setTransactionDetailsLoader(false);
        }
    };

    // Handle pagination changes in modal
    const handleModalPaginationChange = (paginationParams) => {
        if (selectedRecord) {
            let isMonth = selectedRecord.key === 'month';
            let isMatched = selectedRecord.key === 'matchedTrackingNumberCount';

            fetchTransactionDetails(
                selectedRecord,
                isMonth,
                isMatched,
                paginationParams.pageNumber,
                paginationParams.pageSize,
                paginationParams.sortColumn || "CreatedDate",
                paginationParams.sortOrder || "DESCENDING"
            );
        }
    };

    const handleShowDisputedDialog = (item) => {
        setShowDisputedDialogObj({
            show: true,
            filterData: filterData,
            periodDetail: item,
            handleClose: () => setShowDisputedDialogObj(false)
        });
    }

    const handleLinkAction = (item, key) => async () => {
        let data = { ...item, key };
        if (key === 'disputedTrackingNumberCount') {
            handleShowDisputedDialog(item);
            return;
        }
        setSelectedRecord(data);
        setShowDetailModal(true);

        // If Month column is clicked, fetch transaction details
        if (key === 'month') {
            await fetchTransactionDetails(item, 1, 30); // Start with first page, 30 items per page
        }
        else if (key === 'matchedTrackingNumberCount') {
            await fetchTransactionDetails(item, 0, 1, 1, 30); // Fetch matched tracking numbers
        }
        else if (key === 'unMatchedTrackingNumberCount') {
            await fetchTransactionDetails(item, 0, 0, 1, 30); // Fetch matched tracking numbers
        }
    };


    const navigateToReport = () => {
        navigate('/reports/carrier-profit-reports');
    }

    return (
        <main className="carrier-reconciliation-reports">
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec zIndex3">
                    <span>Carrier Reconciliation Reports</span>
                    <div className="top_right_button_container">
                        <button className="btn cus-primary-transparent-btn mr-2" onClick={() => navigate('/reports')}>Back</button>
                        <button disabled={showLoader} className="btn cus-seconday-bg-btn mr-2" onClick={navigateToReport}>Carrier Profitability Report</button>
                        <button disabled={showLoader} className="btn cus-seconday-bg-btn" onClick={() => setfilterData({ ...filterData, showFilter: !filterData.showFilter })}>Filter</button>
                    </div>
                </div>
                {showLoader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}

                <div className='zIndex2'>
                    {filterData.showFilter && (
                        <MonthFilter handleApplyFilter={handleApplyFilter} loader={showLoader} />
                    )}
                </div>

                <div className="reportCardContainer">
                    <div className="card">
                        <h3>Matched Tracking IDs</h3>
                        <p>{formatStaticNumberWithCommas(cardsTotalData.totalMatchedTrackingNumberCount || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Unmatched Tracking IDs</h3>
                        <p>{formatStaticNumberWithCommas(cardsTotalData.totalUnMatchedTrackingNumberCount || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Profit ($)</h3>
                        <p className={cardsTotalData.totalProfit < 0 ? 'pending' : 'credit'}>{`$ ${formatNumberWithCommas(cardsTotalData.totalProfit || 0)}`}</p>
                    </div>
                    <div className="card">
                        <h3>3PL Margin ($)</h3>
                        <p>{formatNumberWithCommas(cardsTotalData.totalFinalMargin || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Total Margin ($)</h3>
                        <p>{formatNumberWithCommas(cardsTotalData.totalMargin || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Carrier Amount ($)</h3>
                        <p>{formatNumberWithCommas(cardsTotalData.totalCarrierRate || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>3PL Amount ($)</h3>
                        <p>{formatNumberWithCommas(cardsTotalData.totalFinalRate || 0)}</p>
                    </div>
                </div>
                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl center-aligned-table">
                            <DataTable
                                tableData={reconciliationReport?.data?.monthlyReports || []}
                                headers={ReconciliationColumns}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={reconciliationReportStatus}
                                filterData={filterData}
                                handleLinkAction={handleLinkAction}
                            />
                        </div>
                    </div>
                    {reconciliationReport?.data?.monthlyReports.length > 0 && (
                        <BatchPagination
                            gridData={reportListing}
                            totalVisualRecords={reportListing.length}
                            numberOfPage={filterData.pageSize}
                            numOfPage={numOfPage}
                            loader={loader}
                            currentPage={filterData.pageIndex}
                            totalPages={filterData.totalPages}
                            totalRecords={reconciliationReport?.totalRecords}
                            setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                            setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                        />
                    )}
                </div>
            </div>
            {showDisputedDialogObj && (
                <DisputedTransactions
                    show={showDisputedDialogObj.show}
                    handleCancel={showDisputedDialogObj.handleClose}
                    reportDetails={showDisputedDialogObj.filterData}
                    periodDetail={showDisputedDialogObj.periodDetail}
                />
            )}
            {showDetailModal && (
                <ReportModals
                    show={showDetailModal}
                    handleCancel={() => {
                        setShowDetailModal(false);
                        // Reset transaction details data when closing modal
                        setTransactionDetails([]);
                        setTransactionDetailsTotalRecords(0);
                    }}
                    selectedRecord={selectedRecord}
                    transactionDetails={transactionDetails}
                    transactionDetailsLoader={transactionDetailsLoader}
                    totalRecords={transactionDetailsTotalRecords}
                    onPaginationChange={handleModalPaginationChange}
                />
            )}
        </main>
    );
}

export default CarrierReconciliationReports;